import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { mdiChartSankeyVariant } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const EmptyAutoTriggerList = memo(() => {
  const { classes, theme } = useStyles();

  return (
    <Box className={classes.root} data-testid="empty-auto-trigger-list">
      <Box className={classes.icon}>
        <MiIcon
          path={mdiChartSankeyVariant}
          color={theme.palette.grey.darkerAccent}
          size={1.2}
        />
      </Box>
      <Typography fontWeight={theme.fontWeight.medium}>
        No Order Auto-Trigger Flows Created
      </Typography>
    </Box>
  );
});

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    borderRadius: "50%",
    backgroundColor: theme.palette.grey.mediumLight,
  },
}));
